; var GoogleMap = (function () {
    'use strict';

    var settings = GoogleMapSettings;
    /*
    {
        containerId: 'map',
        isGrayScale: false,
        isMobileDraggable: false,
        map: {
            centerLat: 46.0655345,
            centerLng: -71.9626027,
            zoom: 15
        },
        markers: [{
            positionLat: 46.0655345,
            positionLng: -71.9626027,
            image: '/images/pin.png',
            title: '365 Boulevard des Bois Francs N',
            url: "https://goo.gl/maps/hYiUjfW28hQ2"
        }]
    };
    */

    var initialize = function () {
        var styles = [];

        if (settings.isGrayScale)
            styles.push({ stylers: [{ saturation: -100 }] });

        var map = new google.maps.Map(document.getElementById(settings.containerId), {
            center: new google.maps.LatLng(settings.map.centerLat, settings.map.centerLng),
            zoom: settings.map.zoom,
            disableDefaultUI: true,
            scrollwheel: false,
            draggable: settings.isMobileDraggable ? true : !('ontouchstart' in document.documentElement),
            styles: styles
        });

        for (var i = 0; i < settings.markers.length; i++) {
            var markerSetting = settings.markers[i];
            var marker = new google.maps.Marker({
                map: map,
                position: new google.maps.LatLng(markerSetting.positionLat, markerSetting.positionLng),
                icon: markerSetting.image,
                title: markerSetting.title,
                url: markerSetting.url
            });

            google.maps.event.addListener(marker, 'click', function () {
                window.open(this.url);
            });
        }

        /*
        $(document).ready(function () {
            setCenterMap();
        });

        $(window).resize(function () {
            setCenterMap();
        });

        function setCenterMap() {
            if ($(window).width() < 992) {
                //position le point plus vers la droite
                var lat = settings.map.centerLat + 0.0009127;
                var lng = settings.map.centerLng - 0.0098955;
                //position le point plus vers la gauche
                var lat = settings.map.centerLat - 0.0009127;
                var lng = settings.map.centerLng + 0.0098955;
                map.setCenter(new google.maps.LatLng(lat, lng));
            }
            else {
                map.setCenter(new google.maps.LatLng(settings.map.centerLat, settings.map.centerLng));
            }
        }
        */
    };

    var asynchronouslyLoadGoogleMapAPI = function () {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + GoogleMapApiKey + '&callback=GoogleMap.initialize';
        document.body.appendChild(script);
    };

    asynchronouslyLoadGoogleMapAPI();
    return {
        initialize: initialize
    };
}());